<template>
  <section class="main">
    <h1 class="intro">{{ $t('HOW_TO_SIDELOAD') }}</h1>
    <div class="row">
      <div class="content">
        <p class="g-text g-text_justify" v-html="$t('SIDELOADING_OPTIONS_DESCRIPTION')"></p>

        <v-accordion
          class="sideloading-accordion"
          anchor="official"
          :heading="$t('OFFICIAL_SIDELOADING_HEADING')">
          <ol class="steps">
            <li
              class="steps__step"
              :class="{
                'accent-animation': $route.query.accent === 'step-1'
              }"
            >
              <img class="steps__icon" src="@/assets/devapp.png" />
              <div @click="purchase" v-html="$t('PLUS_STEP_1', { href: '#' })+' '+'(<a href=\'https://www.youtube.com/watch?v=QFs7uVk7s4Y\' target=\'_blank\'>'+$t('VIDEO_TUTORIAL')+'</a>)'"></div>
            </li>
            <li class="steps__step">
              <img
                class="steps__icon"
                :src="require(`@/assets/themes/${BRAND_KEY}/images/logo-mobile-${theme}.svg`)"
              />
              <html-with-links :html="$t('PLUS_STEP_2', {href: '/my/apple'})+' '+'(<a href=\'https://www.youtube.com/watch?v=-ShhaoaLWyE\' target=\'_blank\'>'+$t('VIDEO_TUTORIAL')+'</a>)'" />
            </li>
          </ol>

          <p class="g-text" style="margin: 20px 0 15px;" v-html="$t('PLUS_DESCRIPTION')"></p>

          <sideloading-options :options="officialOptions" />
        </v-accordion>

        <v-accordion
          class="sideloading-accordion"
          anchor="p2p"
          :heading="$t('P2P_SIDELOADING_HEADING')">
          <ol class="steps">
            <li class="steps__step">
              &nbsp;&nbsp;&nbsp;<html-with-links :html="$t('P2P_STEP_1', {href: '/my/p2p-certificates'})" />
            </li>
          </ol>

          <p class="g-text" style="margin: 20px 0 15px;" v-html="$t('PLUS_DESCRIPTION')"></p>

          <sideloading-options :options="officialOptions" />
        </v-accordion>

        <v-accordion
          class="sideloading-accordion"
          anchor="3rdparty"
          :heading="$t('3RD_PARTY_SIDELOADING_HEADING')">
          <ol class="steps" style="margin-bottom: 15px;">
            <li class="steps__step">
              &nbsp;&nbsp;&nbsp;<html-with-links :html="$t('3RD_PARTY_SIDELOADING_DESC')" />
            </li>
          </ol>
          <sideloading-options v-if="thirdPartyOptions.length" :options="thirdPartyOptions" />
          <br/>
          <p
            class="g-text"
            v-html="$t('3RD_PARTY_SIDELOADING_PROGRAM',{href:'https://rtfm.dbservices.to/#/integrations/easy-certificate-linking'})"
          ></p>

          <!--<p style="margin: 10px 0; font-weight: 700;">Already purchased?</p>

          <div v-if="devCredentialsProviders.length" class="inline-buttons">
            <template v-for="provider in devCredentialsProviders">
              <btn
                type="primary"
                @click.native.prevent="importDevCredetials(provider.href)"
                :key="provider.name"
              >{{ $t('IMPORT_FROM', { from: provider.name }) }}
              </btn>&nbsp;
            </template>
          </div>

          <html-with-links
            style="margin-top: 10px;"
            tag="div"
            :html="$t('INTEGRATE_EASY_LINKING_NOTICE',{link:'https://rtfm.dbservices.to/#/integrations/easy-certificate-linking'})"
          ></html-with-links>-->
        </v-accordion>

        <v-accordion
          class="sideloading-accordion"
          anchor="enterprise"
          :heading="$t('FREE_ENTERPRISE_SIDELOADING_HEADING')">

          <ol class="steps" style="margin-bottom: 15px;">
            <li class="steps__step">
              &nbsp;&nbsp;&nbsp;<html-with-links :html="$t('FREE_ENTERPRISE_SIDELOADING_DESC')" />
            </li>
          </ol>
          <p class="g-text" style="margin-bottom: 15px;" v-html="$t('PLUS_DESCRIPTION')"></p>


          <sideloading-options :options="plusOptions" />
        </v-accordion>

        <!--<v-accordion
          class="sideloading-accordion"
          anchor="developer"
          :heading="$t('FREE_DEVELOPER_SIDELOADING_HEADING')">
          <ol class="steps" style="margin-bottom: 15px;">
            <li class="steps__step">
              &nbsp;&nbsp;&nbsp;<html-with-links :html="$t('FREE_DEVELOPER_SIDELOADING_DESC', {
              altStoreLink: 'https://altstore.io',
              sideloadlyLink: 'https://sideloadly.io/#download'
            })" />
            </li>
          </ol>
          <p class="g-text" style="margin-bottom: 15px;" v-html="$t('PLUS_DESCRIPTION')"></p>
          <sideloading-options :options="plusOptions" />
        </v-accordion>-->
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import HtmlWithLinks from '@/components/HtmlWithLinks.vue';
import VAccordion from '@/components/Accordion.vue';
import SideloadingOptions from '@/components/SideloadingOptions.vue';

export default {
  components: {
    HtmlWithLinks,
    VAccordion,
    SideloadingOptions,
  },
  data() {
    return {
      officialOptions: [],
      thirdPartyOptions: [],
      plusOptions: [],
      devCredentialsProviders: [],
    };
  },
  computed: {
    title() {
      return this.$t('HOW_TO_SIDELOAD_AND_USE_PLUS');
    },
    ...mapState(['theme']),
  },
  methods: {
    purchase(e) {
      if (!e.target?.matches('a[href="#"]')) {
        return;
      }
      e.preventDefault();

      this.$alert(`<div class="g-text">${this.$t('PLUS_DOWNLOAD_APP', { href: 'https://apps.apple.com/us/app/apple-developer/id640199958' })}</div>`);
    },
    importDevCredetials(href) {
      this.$confirm(this.$t('IMPORT_DEV_CREDENTIALS_PROVIDER_CONFIRMATION'))
        .then(() => {
          window.location.href = href;
        });
    },
  },
  created() {
    this.$api.getSideloadingOptions('official').then((response) => {
      this.officialOptions = response;
    });

    this.$api.getSideloadingOptions('3rdparty').then((response) => {
      this.thirdPartyOptions = response;
    });

    /* this.$api.getDevCredentialsProviders()
      .then((response) => {
        this.devCredentialsProviders = response;
      }); */

    this.$api.getSideloadingOptions('plus').then((response) => {
      this.plusOptions = response;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  display: block;
  flex-grow: 1;
}

.row {
  display: flex;
  align-items: flex-start;

  @include notebook {
    flex-wrap: wrap;
  }
}

.content {
  flex-grow: 1;

  @include notebook {
    order: 1;
  }
}

.col {
  &_1 {
    flex-grow: 1;
  }

  &_2 {
    flex: 0 0 192px;
    margin-left: 15px;

    @include notebook {
      margin-left: 0;
      margin-top: 0;
    }
  }

  @include notebook {
    flex: 0 0 100%;
  }
}

.content::v-deep .g-text {
  margin-bottom: 10px;
  line-height: 1.2;
}

.table {
  width: 100%;
  margin: 20px 0;

  th {
    border-bottom: 1px solid #dcd9d9;
    padding-bottom: 10px;
  }

  td {
    padding: 10px;
    vertical-align: middle;
    white-space: pre-line;
    line-height: 1.2;
  }

  td:not(:last-child) {
    border-right: 1px solid #dcd9d9;
  }

  tr:not(:last-child) td {
    border-bottom: 1px solid #dcd9d9;
  }

  td:not(:first-child) {
    text-align: center;
  }

  td:first-child {
    @include tablet {
      width: 150px;
    }
  }
}

.badge {
  display: inline-block;
  background-color: $primary;
  color: #fff;
  padding: 3px 4px 2px 4px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
}

.text {
  text-align: justify;
}

.steps {
  counter-reset: steps;

  &__step {
    display: flex;
    align-items: center;
    font-size: 16px;

    &:not(:last-child) {
      margin-bottom: 15px;

      @include tablet {
        margin-bottom: 10px;
      }
    }

    &::before {
      counter-increment: steps;
      content: counter(steps) ".";
      font-size: 25px;

      @include tablet {
        font-size: 18px;
      }
    }
  }

  &__icon {
    margin: 0 10px;
    max-width: 50px;
    width: 100%;

    @include tablet {
      max-width: 40px;
    }
  }
}

.plus-icon {
  background-color: $primary;
  color: #fff;
  font-size: 21px;
  padding: 10px 0;
  text-align: center;
  border-radius: 4px;
  font-weight: 600;

  @include tablet {
    font-size: 12px;
    padding: 6px 0;
  }
}

.inline-buttons {
  line-height: 33px;
  margin-top: -5px;

  .button {
    display: inline;
  }
}

.sideloading-accordion {
  .g-text {
    margin-bottom: 0;
  }

  &:not(:last-child) {
    margin-bottom: 15px;
  }
}
</style>
